import { getSettingsPageUrl } from '@constants'
import { useBusinessContext } from '@context'
import { useTheme } from '@hooks'
import { useReferralRewards } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaGift } from 'react-icons/fa'
import { NeedsYouRow } from './NeedsYouRow'

interface Props {
  onDismiss: () => void
}

export const ReferralPromoRow: React.FC<Props> = ({ onDismiss }) => {
  const [t] = useTranslation()
  const theme = useTheme()
  const { slug } = useBusinessContext()
  const { data: rewards, isError, isLoading } = useReferralRewards()
  const hasRewards = Boolean(rewards?.length)

  const description = isError
    ? t('dashboard.referral.loadError')
    : hasRewards
    ? t('dashboard.referral.descriptionWithReward', { count: rewards?.length ?? 0 })
    : t('dashboard.referral.description')

  return (
    <NeedsYouRow
      link={getSettingsPageUrl(slug, { page: 'referral' })}
      tint={theme.dashboard.infoTint}
      color={theme.colors.primary}
      icon={<FaGift />}
      title={t('dashboard.referral.title')}
      meta={isLoading ? t('general.loading') : description}
      onDismiss={onDismiss}
    />
  )
}
